import { unstable_createMuiStrictModeTheme as createMuiTheme } from '@mui/material/styles';

export const themeObjectLight = createMuiTheme({
    palette: {
        mode: 'light',
        // alphabetical order
        accordion: {
            backgroundColor: '#eaeaea',
            backgroundColorRefresh: '#EFF1F3',
            backgroundBodyRefresh: '#FFFFFF',
        },
        action: {
            disabledOpacity: 0.5,
        },
        acuityColors: {
            color1: {
                background: '#DC4A5D',
                text: '#FFFFFF',
            },
            color2: {
                background: '#F26B28',
                text: '#FFFFFF',
            },
            color3: {
                background: '#FEB03A',
                text: '#FFFFFF',
            },
            color4: {
                background: '#01AF69',
                text: '#FFFFFF',
            },
            color5: {
                background: '#2180F7',
                text: '#FFFFFF',
            },
            color6: {
                background: 'white',
                text: '#000',
                borderColor: 'black',
            },
        },
        admissionForm: {
            labelColor: '#ACAFB3',
            borderColor: '#808486',
            textColor: '#969696',
            toggleBackground: '#dfdfdf',
            toggleBackgroundDarker: '#bfbfbf',
            patientCardBackground: '#ffffff',
            patientCardBackgroundDarker: '#dfdfdf',
            toggleTextColor: '#7a7a7a',
            selectedBtnBg: '#626466',
            selectedBtnText: '#fff',
            procedureAvgTimeBackground: '#e1e1e1',
            procedureAvgTimeText: '#464444',
            backgroundNotes: '#494B4C',
        },
        attendanceType: {
            ed: '#E25B61',
            ip: '#64A6F9',
            op: '#AF63D3',
            sdec: '#4EAC6F',
            utc: '#b3b3b3',
        },
        avatar: {
            color: '#eee !important',
        },
        referral: {
            colorRequested: '#DC2828',
            colorAcknowledged: '#F15E00',
            colorAssessed: '#CC9900',
            colorCompleted: '#04A12B',
            contrastText: '#fff',
            main: '#2280f7',
            table: {
                textColor: 'rgba(0, 0, 0, 0.52)',
                background: '#e0e0e0',
                hover: '#e2e2e2',
            },
            timeline: {
                background: '#ffffff',
                cardBackground: '#f2f2f2',
                bulletBackground: '#e0e0e0',
                stepActiveBackground: 'rgba(239,68,68,0.08)',
                stepActiveBorderColor: 'rgba(239,68,68,0.35)',
                textPrimary: 'rgba(0, 0, 0, 0.72)',
                textSecondary: 'rgba(0, 0, 0, 0.52)',
                cardBorder: '1px solid rgba(0,0,0,0.52)',
                cardBorderColor: 'rgba(0,0,0,0.52)',
                shadowColor: 'rgba(255,255,255,0.02)',
                stepConnectorBorder: '1px solid rgba(0,0,0,0.52)',
                stepConnectorArrow: '1px solid rgba(0,0,0,0.72)',
                stepIcon: '#fff',
                alertColor: '#EF4444',
            },
        },
        background: {
            paper: '#e2e2e2',
            paperDarker: '#FFFFFF',
            paperHover: '#9e9e9e',
            paperSelected: '#5a5a5a',
            paperSelectedText: '#fff',
            default: '#f2f2f2',
            defaultBackground: '#ffffff',
            infoNote: '#e4e3d2',
            header: '#e3e3e3',
            patientBadge: '#BFC2C7',
            field: '#EFF1F3',
            dialog: '#DEE1E5',
            dialogBorder: '#D2D5D9',
            gridHeader: 'rgba(96,96,96,0.81)',
            even: 'rgba(128,128,128,0.41)',
            odd: 'rgb(255,255,255)',
            listHeader: '#d3d3d3',
            iconPressed: '#e2e2e2',
            panel: '#eae9e9',
        },
        bedManagement: {
            background: '#ffffff',
        },
        blur: 'blur(2px)',
        bookAdmissions: {
            //w
            dayHeader: '#d2d5d9',
            textColor: '#000000',
            calendarDayBackground: '#bfb8b8',
            calendarDayBorder: '#ACAFB3',
            calendarDaysTodayBackground: '#2180f7',
            calendarDaysTodayText: 'white',
            sessionBackground: '#787373',
            sessionTimeLines: '#c9c9c9',
            cardBackground: '#494B4C',
            cardText: 'white',
            tabColor: 'grey',
            tabSelectedColor: 'grey',
            dcLabelBackground: '#D2D5D9',
            infoRowBackground: 'white',
            timelineBackground: 'white',
            timelineBackgroundSelected: '#3D3E40',
            timelineText: 'black',
            timelineTextSelected: 'white',
            settingAccordionBackground: 'white',
            settingMenuItemSelectedBackground: '#D2D5D9',
            settingMenuItemSelectedText: 'black',
            modalBackgroundColor: '#f2f2f2',
            patientCardTextColor: '#626466',
        },
        default: {
            light: '#7986cb',
            main: '#2280f7',
            dark: '#303f9f',
            contrastText: '#000',
            contrastBackground: '#fff',
        },
        designSystem: {
            colors: {
                blue: {
                    500: '#64A6F9',
                    550: '#2180F7',
                    600: '#0864D8',
                    700: '#054595',
                    800: '#032C5F',
                    900: '#021936',
                },
                neutral: {
                    500: '#f6fafd',
                    550: '#eef4fb',
                    600: '#e3ecf5',
                    650: '#d4e2f0',
                    700: '#bbcbdb',
                    750: '#9fafc0',
                    800: '#7b8a9a',
                    850: '#586470',
                    900: '#3b4a59',
                    950: '#24313e',
                },
                green: {
                    500: '#C9E7D4',
                    600: '#94CEA8',
                    700: '#4EAC6F',
                    750: '#398F57',
                    800: '#2E6441',
                    900: '#142B1C',
                },
                amber: {
                    500: '#FEE4B1',
                    600: '#FEC864',
                    700: '#F7A202',
                    750: '#E08002',
                    800: '#B56600',
                    900: '#804501',
                },
                red: {
                    500: '#F4C3C6',
                    600: '#ED979A',
                    700: '#E25B61',
                    750: '#CC494F',
                    800: '#B43238',
                    900: '#70191C',
                },
                purple: {
                    500: '#D0A2E5',
                    600: '#C480E5',
                    700: '#B640EE',
                    750: '#9B13DB',
                    800: '#820FB9',
                    900: '#6B049B',
                },
                pink: {
                    500: '#FCCEEE',
                    600: '#F670C7',
                    700: '#DD2590',
                    750: '#C11574',
                    800: '#9E165F',
                    900: '#851651',
                },
                teal: {
                    500: '#B1ECF3',
                    600: '#71E5F4',
                    700: '#00BCD4',
                    750: '#009BAE',
                    800: '#028191',
                    900: '#006471',
                },
                royal: {
                    500: '#C7C2FF',
                    600: '#8569F2',
                    700: '#6938EF',
                    750: '#5925DC',
                    800: '#4A1FB8',
                    900: '#3E1C96',
                },
                white: '#FFFFFF',
                black: '#000000',
            },
            palette: {
                light3: '#ACAFB3',
                light2: '#BFC2C7',
                light1: '#D2D5D9',
                neutral0: '#DEE1E5',
                neutral1: '#EFF1F3',
                dark1: '#FFFFFF',
                dark2: '#FFFFFF',
                text1: '#626466',
                text2: '#494B4C',
                boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
            },
        },
        documentViewer: {},
        error: {
            light: '#ff9595',
            main: '#FF6868',
            dark: '#cc5353',
            contrastText: '#ffffff',
        },
        fieldsetBorderColor: {
            primary: 'rgba(0, 0, 0, 0.23)',
            hover: 'rgba(0, 0, 0)',
        },
        flags: {
            singleIconFlag: {
                default: '#bfbfbf',
                active: '#222',
                activeColor: '#fff',
                ice: '#0b5394',
                iceColor: '#fff',
                noneColor: '#01af69',
                confirmColor: '#DC4A5D',
                suspectedColor: '#FEB03A',
            },
        },
        info: {
            main: '#64748B',
            contrastText: '#fff',
        },
        inPatient: {
            text: '#313233',
            questionText: '#313233',
            formBackground: '#eff1f3',
            inputBackground: '#ffffff',
            accordionBackground: '#eff1f3',
            accordionBorder: '#eff1f3',
            stepperRoot: '#f0f1f3',
            root: '#a0a0a0',
            stepperActive: '#2180F7',
            dncprAnswer: '#aeb3b8',
            stepPatientNumber: 'white',
            tabTextColor: '#313030',
            tabSelectedTextColor: '#2180f7',
            iconBackground: '#626466',
            emptyScreen: '#ffffff',
            border: '#626466',
            barCode: '#606060CE',
            divider: '#E6E6E6',
        },
        login: {
            text: '#2d80f7',
            border: '#ccced4',
            // border: "#626466", // Uncomment at login page refresh
            btnText: '#f2f2f2',
            footer: '#000000',
        },
        mainScreenButton: {
            headerFilled: '#D2D5D9',
            formFilledDetails: '#EFF1F3',
        },
        nhsUpsertBlock: {
            background: '#EDEDED',
        },
        notes: {
            background: '#fff9c8',
            backgroundHighlight: '#b2a357',
            text: '#313233',
            textHighlight: '#ffffff',
            border: '#faebcc',

            systemBackground: '#EFF1F3',
            systemText: '#000000',

            headerBackground: '#7EA0D8',
            headerText: '#000000',
            headerPlanBackground: '#85c2c6',
            headerPlanText: '#000000',
            headerLocationBackground: '#C1C1C1',
            headerLocationText: '#000000',

            accentBackground1: '#f0ad4e',
            accentText1: '#fefad1',
            accentBackground2: '#ffffff',
            accentText2: '#444444',
            accentBackground3: '#d3b87f',
            accentText3: '#fff',
        },
        observation: {
            white: '#FFFFFF',
            yellow: '#FFF6B2',
            amber: '#FFC790',
            pink: '#FECDDC',
            red: '#F79781',
            border: '#494B4C',
            text: '#494B4C',
        },
        patientCard: {
            main: {
                color: '#000',
                background: '#fff',
            },
            blue: {
                color: '#ffffff',
                background: '#4fc3f7',
            },
            green: {
                color: '#ffffff',
                background: '#01AF69',
            },
            amber: {
                color: '#ffffff',
                background: '#ffb74d',
            },
            yellow: {
                color: '#000000',
                background: '#F8E71C',
            },
            red: {
                color: '#ffffff',
                background: '#DC4A5D',
            },
            burgundy: {
                color: '#ffffff',
                background: '#A32626',
            },
        },
        primary: {
            light: '#7986cb',
            // main: "#3f51b5",
            // main: "#2280f7",
            main: '#2180f7',
            dark: '#303f9f',
            mainColor: '#000',
            contrastText: '#fff',
            contrastTextAlarmChip: '#000',
        },
        secondary: {
            light: '#9a9593',
            main: '#837c7c',
            dark: '#5e5c5c',
            contrastText: '#000',
        },
        tableHeader: {
            background: '#FFFDFD',
        },
        tb: {
            root: {
                background: '#f2f2f2',
            },
            background: {
                main: 'transparent',
                window: '#434343',
                inWindow: '#252525',
            },
            color: {
                main: '#777',
                sub: '#d2d2d2',
            },
        },
        tertiary: {
            main: '#281e21',
            contrastText: '#fff',
        },
        text: {
            primary: 'rgba(0, 0, 0, 0.92)',
            secondary: 'rgba(0, 0, 0, 0.75)',
        },
    },
});

export const themeObjectDark = createMuiTheme({
    palette: {
        mode: 'dark',
        //alphabetical order
        accordion: {
            backgroundColor: '#2e2d2d',
            backgroundColorRefresh: '#313233',
            backgroundBodyRefresh: '#313233',
        },
        action: {
            disabledOpacity: 0.5,
        },
        acuityColors: {
            color1: {
                background: '#DC4A5D',
                text: '#FFFFFF',
            },
            color2: {
                background: '#F26B28',
                text: '#FFFFFF',
            },
            color3: {
                background: '#FEB03A',
                text: '#FFFFFF',
            },
            color4: {
                background: '#01AF69',
                text: '#FFFFFF',
            },
            color5: {
                background: '#2180F7',
                text: '#FFFFFF',
            },
            color6: {
                background: 'black',
                text: '#FFFFFF',
            },
        },
        admissionForm: {
            labelColor: '#ACAFB3',
            borderColor: '#626466',
            textColor: '#ACAFB3',
            toggleBackground: '#3D3E40',
            toggleBackgroundDarker: '#313233',
            patientCardBackground: '#3D3E40',
            patientCardBackgroundDarker: '#313233',
            toggleTextColor: '#a1a1a1',
            selectedBtnBg: '#FFFFFF',
            selectedBtnText: '#000000',
            procedureAvgTimeBackground: '#252525',
            procedureAvgTimeText: '#dfdfdf',
            backgroundNotes: '#494B4C',
        },
        attendanceType: {
            ed: '#E25B61',
            ip: '#64A6F9',
            op: '#AF63D3',
            sdec: '#4EAC6F',
            utc: '#ffffff',
        },
        avatar: {
            color: '#222 !important',
        },
        referral: {
            colorRequested: '#DC2828',
            colorAcknowledged: '#F97415',
            colorAssessed: '#E7B008',
            colorCompleted: '#21C45D',
            contrastText: '#fff',
            main: '#1DA1FF',
            table: {
                textColor: '#ACAFB3',
                background: '#434343',
                hover: '#313233',
            },
            timeline: {
                background: '#222425',
                cardBackground: '#252525',
                bulletBackground: '#313233',
                stepActiveBackground: 'rgba(220,40,40,0.08)',
                stepActiveBorderColor: 'rgba(220,40,40,0.35)',
                textPrimary: 'rgba(220, 220, 220, 0.92)',
                textSecondary: 'rgba(220, 220, 220, 0.52)',
                cardBorder: '1px solid rgba(255,255,255,0.06)',
                cardBorderColor: 'rgba(255,255,255,0.06)',
                shadowColor: 'rgba(255,255,255,0.02)',
                stepConnectorBorder: '1px solid rgba(255,255,255,0.12)',
                stepConnectorArrow: '1px solid rgba(255,255,255,0.22)',
                stepIcon: 'rgba(220, 220, 220, 0.92)',
                alertColor: '#DC2828',
            },
        },
        background: {
            paper: '#434343',
            paperDarker: '#313233',
            paperHover: '#8e8e8e',
            paperSelected: '#252525',
            paperSelectedText: '#fff',
            default: '#252525',
            defaultBackground: '#222425',
            infoNote: '#e4e3d2',
            header: '#434343',
            patientBadge: '#3d3e40',
            field: '#252525',
            dialog: '#3D3E40',
            dialogBorder: '#494B4C',
            gridHeader: 'rgba(14,14,14,0.81)',
            even: 'rgba(86,86,86,0.41)',
            odd: 'rgba(0,0,0,0.41)',
            listHeader: '#424242',
            iconPressed: '#414243',
            panel: '#313233',
        },
        bedManagement: {
            background: '#222425',
        },
        blur: 'blur(2px)',
        bookAdmissions: {
            dayHeader: '#373737',
            textColor: '#ffffff',
            calendarDayBackground: '#6a6969',
            calendarDayBorder: '#252525',
            calendarDaysTodayBackground: 'white',
            calendarDaysTodayText: '#2180f7',

            sessionBackground: '#343333',
            sessionTimeLines: '#626466',
            cardBackground: 'white',
            cardText: 'black',
            tabColor: 'white',
            tabSelectedColor: 'white',
            dcLabelBackground: '#3D3E40',
            infoRowBackground: '#3d3e40',
            timelineBackground: '#3D3E40',
            timelineBackgroundSelected: 'white',
            timelineText: 'white',
            timelineTextSelected: 'black',
            settingAccordionBackground: '#313233',
            settingMenuItemSelectedBackground: '#434343',
            settingMenuItemSelectedText: 'white',
            modalBackgroundColor: '#252525',
            patientCardTextColor: '#ACAFB3',
        },
        default: {
            light: '#7986cb',
            main: '#2280f7',
            dark: '#303f9f',
            contrastText: '#000',
            contrastBackground: '#fff',
        },
        designSystem: {
            colors: {
                blue: {
                    500: '#64A6F9',
                    550: '#2180F7',
                    600: '#0864D8',
                    700: '#054595',
                    800: '#032C5F',
                    900: '#021936',
                },
                neutral: {
                    500: '#ACAFB3',
                    550: '#626466',
                    600: '#494B4C',
                    650: '#494B4C',
                    700: '#3D3E40',
                    750: '#3D3E40',
                    800: '#313233',
                    850: '#313233',
                    900: '#222425',
                    950: '#222425',
                },
                green: {
                    500: '#C9E7D4',
                    600: '#94CEA8',
                    700: '#4EAC6F',
                    750: '#398F57',
                    800: '#2E6441',
                    900: '#142B1C',
                },
                amber: {
                    500: '#FEE4B1',
                    600: '#FEC864',
                    700: '#F7A202',
                    750: '#E08002',
                    800: '#B56600',
                    900: '#804501',
                },
                red: {
                    500: '#F4C3C6',
                    600: '#ED979A',
                    700: '#E25B61',
                    750: '#CC494F',
                    800: '#B43238',
                    900: '#70191C',
                },
                purple: {
                    500: '#D0A2E5',
                    600: '#C480E5',
                    700: '#B640EE',
                    750: '#9B13DB',
                    800: '#820FB9',
                    900: '#6B049B',
                },
                pink: {
                    500: '#FCCEEE',
                    600: '#F670C7',
                    700: '#DD2590',
                    750: '#C11574',
                    800: '#9E165F',
                    900: '#851651',
                },
                teal: {
                    500: '#B1ECF3',
                    600: '#71E5F4',
                    700: '#00BCD4',
                    750: '#009BAE',
                    800: '#028191',
                    900: '#006471',
                },
                royal: {
                    500: '#C7C2FF',
                    600: '#8569F2',
                    700: '#6938EF',
                    750: '#5925DC',
                    800: '#4A1FB8',
                    900: '#3E1C96',
                },
                white: '#FFFFFF',
                black: '#000000',
            },
            palette: {
                light3: '#ACAFB3',
                light2: '#626466',
                light1: '#494B4C',
                neutral0: '#3D3E40',
                neutral1: '#3D3E40',
                dark1: '#313233',
                dark2: '#222425',
                text1: '#ffffff',
                text2: '#ffffff',
                boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.25)',
            },
        },
        documentViewer: {},
        error: {
            light: '#ff9595',
            main: '#FF6868',
            dark: '#cc5353',
            contrastText: '#ffffff',
        },
        fieldsetBorderColor: {
            primary: 'rgba(255, 255, 255, 0.23)',
            hover: 'rgba(255, 255, 255)',
        },
        flags: {
            singleIconFlag: {
                default: '#bfbfbf',
                active: '#222',
                activeColor: '#fff',
                ice: '#0b5394',
                iceColor: '#fff',
                noneColor: '#01af69',
                confirmColor: '#DC4A5D',
                suspectedColor: '#FEB03A',
            },
        },
        info: {
            light: '#ffffff',
            main: '#ffffff',
            dark: '#ffffff',
            contrastText: '#000000',
        },
        inPatient: {
            text: 'white',
            questionText: '#ACAFB3',
            formBackground: '#313233',
            inputBackground: '#3D3E40',
            accordionBackground: '#494b4c',
            accordionBorder: '#626466',
            stepperRoot: '#3D3E40',
            root: '#3D3E40',
            stepperActive: '#2180F7',
            dncprAnswer: '#3D3E40',
            stepPatientNumber: '#ACAFB3',
            tabTextColor: '#ACAFB3',
            tabSelectedTextColor: 'white',
            iconBackground: '#494B4C',
            emptyScreen: '#333333',
            border: '#626466',
            barCode: '#ffffff',
            divider: '#ffffff1f',
        },
        login: {
            text: '#8bbeff',
            // border: "#626466", Uncomment at login page refresh
            border: '#000000',
            btnText: '#f2f2f2',
            footer: '#C0C0C0',
        },
        mainScreenButton: {
            headerFilled: '#626466',
            formFilledDetails: '#222425',
        },
        nhsUpsertBlock: {
            background: '#727272',
        },
        notes: {
            background: '#fff9c8',
            backgroundHighlight: '#b2a357',
            text: '#313233',
            textHighlight: '#ffffff',
            border: '#faebcc',

            systemBackground: '#3D3E40',
            systemText: '#FFFFFF',

            headerBackground: '#7EA0D8',
            headerText: '#000000',
            headerPlanBackground: '#85c2c6',
            headerPlanText: '#000000',
            headerLocationBackground: '#C1C1C1',
            headerLocationText: '#000000',

            accentBackground1: '#f0ad4e',
            accentText1: '#fefad1',
            accentBackground2: '#ffffff',
            accentText2: '#444444',
            accentBackground3: '#d3b87f',
            accentText3: '#fff',
        },
        observation: {
            white: '#FFFFFF',
            yellow: '#FFF6B2',
            amber: '#FFC790',
            pink: '#FECDDC',
            red: '#F79781',
            border: '#222425',
            text: '#222425',
        },
        patientCard: {
            main: {
                color: '#fff',
                background: '#000',
            },
            blue: {
                color: '#ffffff',
                background: '#4fc3f7',
            },
            green: {
                color: '#ffffff',
                background: '#01AF69',
            },
            amber: {
                color: '#ffffff',
                background: '#ffb74d',
            },
            yellow: {
                color: '#000000',
                background: '#F8E71C',
            },
            red: {
                color: '#ffffff',
                background: '#DC4A5D',
            },
            burgundy: {
                color: '#ffffff',
                background: '#A32626',
            },
        },
        primary: {
            light: '#7986cb',
            main: '#2180f7',
            dark: '#303f9f',
            mainColor: '#fff',
            contrastText: '#fff',
            contrastTextAlarmChip: '#fff',
        },
        secondary: {
            light: '#666666',
            main: '#666666',
            dark: '#666666',
            contrastText: '#ffffff',
        },
        tableHeader: {
            background: '#383838',
        },
        tb: {
            root: {
                background: '#000',
            },
            background: {
                main: 'transparent',
                window: '#434343',
                inWindow: '#252525',
            },
            color: {
                main: '#fff',
                sub: '#2280f7',
            },
        },
        tertiary: {
            main: '#ffffff',
            contrastText: '#000000',
        },
        text: {
            primary: 'rgba(255, 255, 255, 0.92)',
            secondary: 'rgba(255, 255, 255, 0.75)',
        },
    },
});
